/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';

const withIsolatedInput = Component =>
  function WithIsolatedInput({ onInputChange, restrictions, ...otherProps }) {
    const [input, setInput] = useState('');

    const handleInputChange = event => {
      if (restrictions) {
        if (event.target.value.toString().search(restrictions) !== -1) {
          return;
        }
      }

      setInput(event.target.value);
    };

    useEffect(() => {
      if (onInputChange) {
        onInputChange(input);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [input]);

    return <Component value={input} onChange={handleInputChange} {...otherProps} />;
  };

export default withIsolatedInput;
